import * as React from 'react';
import images from 'react-payment-inputs/images';

import { Styled } from './styled'

export const PaymentMethodLineInput = (props) => {
  const {
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
    getCardImageProps,
    onCardNumberChange,
    onExpiryChange,
    onCvcChange,
    onSubmit,
    isValid
  } = props;
  return (
    <>
      <Styled.CardImage {...getCardImageProps({ images })} />
      <Styled.CardNumberInput {...getCardNumberProps({ onChange: onCardNumberChange })} />
      <Styled.CardExpiryCvcInput {...getExpiryDateProps({ onChange: onExpiryChange })} />
      <Styled.CardExpiryCvcInput {...getCVCProps({ onChange: onCvcChange })} />
      <Styled.CardInputButton
        isValid={isValid}
        // eslint-disable-next-line react/jsx-no-bind
        onClick={isValid ? onSubmit : () => {}}
      >
        Apply
      </Styled.CardInputButton>
    </>
  );
};
